(function () {
  if (window.DiiseaBlogListing && window.DiiseaBlogListing.__ready) {
    return;
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function enhanceTopicsScroll(root) {
    var scroller = root.querySelector('[data-diisea-blog-listing-topics] .diisea-blog-listing__topics-list');
    if (!scroller) return;
    var active = scroller.querySelector('.diisea-blog-listing__topics-link.is-active');
    if (!active || typeof active.scrollIntoView !== 'function') return;
    try {
      active.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'auto' });
    } catch (err) {
      active.scrollIntoView(false);
    }
  }

  function setActiveLink(links, current) {
    links.forEach(function (link) {
      var on = link === current;
      link.classList.toggle('is-active', on);
      if (on) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function initInPageNav(root) {
    var allLinks = toArray(root.querySelectorAll('.diisea-blog-listing__topics-link'));
    var links = toArray(root.querySelectorAll('[data-diisea-topic-jump]'));
    if (!links.length) return;

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setActiveLink(allLinks.length ? allLinks : links, link);
        try {
          link.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        } catch (err) {
          return;
        }
      });
    });

    if (!('IntersectionObserver' in window)) return;

    var sections = toArray(root.querySelectorAll('.diisea-blog-listing__topic[id]'));
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.id;
          var match = links.filter(function (link) {
            return link.getAttribute('href') === '#' + id;
          })[0];
          if (match) setActiveLink(allLinks.length ? allLinks : links, match);
        });
      },
      { rootMargin: '-35% 0px -50% 0px', threshold: 0 }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.listingReady === 'true') return;
    enhanceTopicsScroll(root);
    initInPageNav(root);
    root.dataset.listingReady = 'true';
  }

  function initAll(scope) {
    var base = scope && scope.nodeType ? scope : document;
    var roots = [];

    if (base.nodeType === 1 && base.matches && base.matches('[data-diisea-blog-listing]')) {
      roots.push(base);
    }
    if (base.querySelectorAll) {
      toArray(base.querySelectorAll('[data-diisea-blog-listing]')).forEach(function (node) {
        if (roots.indexOf(node) === -1) roots.push(node);
      });
    }

    roots.forEach(initRoot);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var scope = event.target || document;
    toArray(scope.querySelectorAll ? scope.querySelectorAll('[data-diisea-blog-listing]') : []).forEach(function (root) {
      delete root.dataset.listingReady;
    });
    if (scope.matches && scope.matches('[data-diisea-blog-listing]')) {
      delete scope.dataset.listingReady;
    }
    initAll(scope);
  });

  if (document.readyState !== 'loading') {
    initAll(document);
  }

  window.DiiseaBlogListing = {
    init: initAll,
    __ready: true
  };
})();
